import React from 'react';
import DesignEditor from './DesignEditor';
import './DesignEditor.css';

/**
 * DesignEditorModal – full-screen modal wrapping the DesignEditor.
 *
 * Props:
 *   open                  – boolean, controls visibility
 *   onClose               – called when the user closes without exporting
 *   onExport(base64, json) – called with the final data-URL + fabric JSON
 *   title                 – modal title (default: "Design Editor")
 *   initialImage          – optional base64/URL to pre-load as the canvas background
 *   designJson            – optional saved fabric.js JSON to restore full design
 *   eventImages           – array of { name, src } for "Insert Event Image" in toolbar
 *   preset                – optional { w, h } canvas size
 */
const DesignEditorModal = ({ open, onClose, onExport, title, initialImage, designJson, eventImages, preset }) => {
  if (!open) return null;

  return (
    <div className="de-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="de-modal">
        <div className="de-modal-header">
          <h3>{title || 'Design Editor'}</h3>
          <button className="de-modal-close" onClick={onClose}>✕</button>
        </div>
        <DesignEditor
          initialImage={initialImage}
          designJson={designJson}
          eventImages={eventImages}
          preset={preset}
          onExport={(dataUrl, json) => {
            onExport(dataUrl, json);
            onClose();
          }}
        />
      </div>
    </div>
  );
};

export default DesignEditorModal;
